// Browser-only persistence of the user's one-time consent to let widgets
// sign Vault SDK requests with the connected wallet. The grant is GLOBAL
// (one approval covers every widget from every agent) and remembered
// across sessions — see docs/superpowers/specs/2026-05-27-widget-sign-consent-design.md.
//
// The connected wallet signs raw bytes silently (no native per-signature
// prompt), so this consent IS the only user gesture gating the signing
// surface. `revokeWidgetSign` is the escape hatch back to no-signing.

const KEY = 'cef-vault:widget-sign-consent';
const GRANTED = 'granted';

export function isWidgetSignGranted(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage.getItem(KEY) === GRANTED;
  } catch {
    return false;
  }
}

export function grantWidgetSign(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(KEY, GRANTED);
  } catch {
    /* private-mode / quota — degrade to prompting next session */
  }
}

export function revokeWidgetSign(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* nothing to do */
  }
}
